const state = {
  navIndex: null,
};
const getters = {
  getNavIndex: state => {
    if (state.navIndex == null) {
      let temp = localStorage.getItem('navIndex');
      if (temp != null) {
        state.navIndex = parseInt(temp);
      }
    }
    return state.navIndex;
  }
};
const mutations = {
  SET_NAV_INDEX(state, index) {
    index = parseInt(index)
    if (!isNaN(index)) {
      state.navIndex = index;
    } else {
      state.navIndex = -1;
    }
    localStorage.setItem('navIndex', state.navIndex);
  }
};
const actions = {
  setNavIndex({
    commit
  }, index) {
    commit('SET_NAV_INDEX', index);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/nav-index.js